export default __webpack_public_path__ + "static/media/nodejs-original.7ca28bcc.svg";